import { render, staticRenderFns } from "./IconShieldCheck.vue?vue&type=template&id=bd9e976e&functional=true&"
import script from "./IconShieldCheck.vue?vue&type=script&lang=js&"
export * from "./IconShieldCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports